import { Injectable } from '@angular/core'

import { SuperAdminAlert } from 'app/_shared/interfaces/SuperAdminAlert'

import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class AlertService extends ApiService {
  getGlobalAlerts() {
    return this.get<SuperAdminAlert[]>(`${this.apiUrl}/alerts/get-storefront-alerts`)
  }
}
